import {ClassificationReportContext} from '../../context'
import Search from '../../../../components/Search'
import {useContext} from 'react'
import PredefinedDateRange from '../../../../components/DateRangePicker/PreDefinedDateRange'
import MultipleSelect from '../../../../components/MultiSelect/MultiSelect'
import {isEmpty} from '../../../../utils/common'
import ExportCSVButton from '../../components/ExportCSVButton'
import { MIN_DATE_RANGE } from '../../utils'

const ClassificationReportHeader = () => {
  const {
    onSearch,
    onDateChange,
    classifications,
    isClassificationsLoading,
    onChangeClassificationFilter,
    onDownloadCSV,
    reportData,
    isLoading,
  } = useContext(ClassificationReportContext)
  const dateRangeLabel = localStorage.getItem('dateRangeLabel')

  const handleDateChange = (startDate: any, endDate: any) => {
    onDateChange && onDateChange(startDate, endDate)
  }

  return (
    <div className='d-flex flex-wrap justify-content-between align-items-end mb-10'>
      <div className='d-flex gap-10 align-items-end'>
        <Search
          onSearch={(searchTerm: string) => {
            onSearch && onSearch(searchTerm)
          }}
        />
        <MultipleSelect
          id={`classification-filter`}
          label='Classification'
          options={classifications}
          className='w-200px'
          placeholder='Select Classification'
          allValuesSelectedText={'Classification: All'}
          isLoading={isClassificationsLoading}
          handleSelected={onChangeClassificationFilter}
        />
      </div>
      <div className='d-flex gap-5 align-itens-end'>
        <ExportCSVButton
          onExportCSV={onDownloadCSV}
          isLoading={isLoading}
          hide={isEmpty(reportData)}
        />

        <div className='w-250px'>
          <PredefinedDateRange
            cb={handleDateChange}
            getLbl={() => {}}
            defaultValue={dateRangeLabel || 'Last 90 Days'}
            includeCurrantDay={true}
            startDate={MIN_DATE_RANGE}
          />
        </div>
      </div>
    </div>
  )
}

export default ClassificationReportHeader
